module.exports = __webpack_public_path__ + "img/part-4-title.06c0a849.png";